module.exports = __webpack_public_path__ + "static/media/google-button.c1026d21.svg";